import { useFormBaseHandler } from "./useFormBaseHandler";

export function useFormUpdate(resource, operation) {
  return useFormBaseHandler(resource, operation, "update");
}
